import React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import {grey} from '@mui/material/colors';
import {
    formatDisplayTime,
    calculateTimeblockScheduledAndAvailableHours,
    isTimeblockOverlappingWindow
} from "../../helpers/ShiftPlanHelper";
import {
    SHIFT_PLAN_TIMEBLOCK_MIN_WIDTH_REM,
    SHIFT_PLAN_TIMEBLOCK_WIDTH_VW
} from '../../domain/ShiftPlanConstants';

const rowHeight = '2.2rem';

const styles = {
    header: {
        width: `${SHIFT_PLAN_TIMEBLOCK_WIDTH_VW}vw`,
        height: rowHeight,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        border: '0.0625rem solid #ccc',
        boxSizing: 'border-box',
        marginBottom: '0.25rem',
        minWidth: `${SHIFT_PLAN_TIMEBLOCK_MIN_WIDTH_REM}rem`,
        padding: '0.125rem',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        fontWeight: 'bold',
        backgroundColor: grey[100],
        cursor: 'default'
    },
    headerTopRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    serviceDotsRow: {
        display: 'flex',
        justifyContent: 'center',
        gap: '0.25rem',
    },
    serviceDotItem: {
        display: 'flex',
        alignItems: 'center'
    },
    colorDot: {
        width: '0.5rem',
        height: '0.5rem',
        borderRadius: '50%'
    },
    availablePerformers: {
        color: grey[600],
        fontSize: '0.75rem',
        fontWeight: 'normal',
        paddingTop: '0.1rem',
    }
};

export default function ShiftPlanTimeblockHeader({timeblocks, performerEnrollments, selectedDate, serviceTypePlans = []}) {
    return (
        <>
            {timeblocks.map((timeblock, idx) => (
                <Grid item key={idx} sx={styles.header}>
                    <Box sx={styles.headerTopRow}>
                        <Typography variant="body2">
                            {formatDisplayTime(timeblock, selectedDate)}
                        </Typography>

                        <Typography variant="body2" sx={styles.availablePerformers}>
                            ({calculateTimeblockScheduledAndAvailableHours(timeblock, performerEnrollments)})
                        </Typography>
                    </Box>
                    <Box sx={styles.serviceDotsRow}>
                        {serviceTypePlans
                            .filter(serviceTypePlan => isTimeblockOverlappingWindow(timeblock, serviceTypePlan.startTime, serviceTypePlan.endTime))
                            .map(serviceTypePlan => (
                                <Box key={serviceTypePlan.id} sx={styles.serviceDotItem}>
                                    <Box sx={{...styles.colorDot, backgroundColor: serviceTypePlan.serviceType.primaryColor}}/>
                                </Box>
                            ))}
                    </Box>
                </Grid>
            ))}
        </>
    );
}